{
  "el": {
    "integration": {
      "actions": {
        "goTo": "Μετάβαση: {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "API tokens",
        "create_failed": "Η δημιουργία απέτυχε",
        "crm_id": "{integration_oid_type} ID στο «{integration_name}»: {integration_oid}",
        "description": "Περιγραφή",
        "error": "σφάλμα",
        "integration": "Ενσωμάτωση",
        "integrationOID": "ID ενσωμάτωσης",
        "last_sync_with": "Τελευταίος συγχρονισμός με «{integration_name}» ({last_sync_at})",
        "status": "κατάσταση",
        "synced_at": "Τελευταίος συγχρονισμός: ",
        "title": "Ενσωματώσεις που διαχειρίζεται η Ziggu",
        "update_failed": "απέτυχε η ενημέρωση"
      },
      "record_actions": {
        "delete": "Για να διαγραφεί οριστικά η εγγραφή «{record_type}» στο Ziggu (και να μην επανεμφανιστεί), η εγγραφή «{record_type}» <strong>πρέπει πρώτα να διαγραφεί στο σύστημα «{integration_name}»</strong>."
      },
      "toasts": {
        "update": "Η ενσωμάτωση ενημερώθηκε"
      }
    }
  }
}
